import React ,{useState } from "react";
import { useQuery } from '@apollo/client';
import { FETCH_MY_BANKS } from "../../bankIntegration/bankIntegrationPageWidget";
import { Spinner } from "evergreen-ui";
import { AppInputFieldSelect } from "../../../../../widget/styledComponents/input_field.style";






export default function  SelectBankAccount ({ onSelect })  {
    
    const { loading,error,data }  = useQuery(FETCH_MY_BANKS);;
    
    const [selectedOption, setSelectedOption] = useState('');
    
    if (loading) return <Spinner/>;
    if (error) return <p>Error: {error.message}</p>;
    const options = data.facilityManager.bankAccounts;
    const handleSelect = (event) => {
      const selectedValue = event.target.value;
      setSelectedOption(selectedValue);
      console.log("Selected value:", selectedValue);
      onSelect(selectedValue)
    };
      return (
        <div>
            <AppInputFieldSelect
                className="browser-default" required
                 value={selectedOption} onChange={handleSelect}
                >
                <option value="" disabled selected>Choose your option</option>
                {options.map((option) => (
                <option key={option._id}  value={option._id}
                >
                    {option.accountNumber}-{option.bankName}
                </option >
                ))}
            </AppInputFieldSelect>
        </div>
      )
    }
    


